// Module
var code = "<thead> <tr> <th id=\"column1header\" class=\"grid-col1\">Field</th> <th id=\"column2header\" class=\"grid-col2\"></th> <th class=\"grid-col3\"></th> </tr> </thead> <tbody></tbody> ";
// Exports
export default code;